import {BaseService} from "@/service/BaseService.ts";

export class GenerateCodeService {
    static generate = (others: any, applicationId: number) => {
        return BaseService.apiClient(others).get(`/${applicationId}`, {
            baseURL: import.meta.env.VITE_GENERATE_JAVA_BASE_URL
        })
    }
    static generateKotlin = (others: any, applicationId: number) => {
        return BaseService.apiClient(others).get(`/${applicationId}`, {
            baseURL: import.meta.env.VITE_DOWNLOAD_BASE_URL
        })
    }
    static checkStatus = (others: any, applicationId: number) => {
        return BaseService.apiClient(others).get(`/status/${applicationId}`, {
            baseURL: import.meta.env.VITE_GENERATE_JAVA_BASE_URL
        })
    }
}